export default "__VITE_ASSET__BDhWQqPn__"